import { moduleName } from './constants';

const config = (state: any) => state[moduleName].config;
const status = (state: any) => state[moduleName].status;

export const selectors = {
    config,
    status,
};


// WEBPACK FOOTER //
// ./src/redux/modules/hft/selectors.tsx